var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9af17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M987.4 986.8L687.2 686.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M364.4 72c39.4 0 77.7 7.7 113.6 22.9 34.8 14.7 66 35.8 92.8 62.6 26.8 26.8 47.9 58.1 62.6 92.8 15.2 36 22.9 74.2 22.9 113.6s-7.7 77.7-22.9 113.6c-14.7 34.8-35.8 66-62.6 92.8-26.8 26.9-58 48-92.8 62.7-36 15.2-74.2 22.9-113.6 22.9s-77.7-7.7-113.6-22.9c-34.8-14.7-66-35.8-92.8-62.6-26.8-26.8-47.9-58.1-62.6-92.8-15.2-36-22.9-74.2-22.9-113.6s7.7-77.7 22.9-113.6c14.7-34.8 35.8-66 62.6-92.8 26.8-26.8 58.1-47.9 92.8-62.6 35.9-15.3 74.1-23 113.6-23m0-65C167.2 7 7.4 166.8 7.4 364c0 197.1 159.8 357 357 357 197.1 0 357-159.8 357-357-.1-197.2-159.9-357-357-357z"
  })));
}

export default SvgSearch;